export const steps = ['Matriz', 'Contrato'];
